import {materialTypes} from '../common/MaterialTypes'
import {getMaterial} from '../common/Materials'

export const previewAxisConfig = {
  vertex: {
    innerActiveMaterial: getMaterial(materialTypes.cyan),
    innerInactiveMaterial: getMaterial(materialTypes.transparent),
    outerActiveMaterial: getMaterial(materialTypes.cyan),
    outerInactiveMaterial: getMaterial(materialTypes.transparent),
    innerSize: 0.1,
    outerSize: 0.3,
    innerSegments: 32,
    outerSegments: 32,
  },
  edge: {
    innerActiveMaterial: getMaterial(materialTypes.cyan),
    innerInactiveMaterial: getMaterial(materialTypes.transparent),
    outerActiveMaterial: getMaterial(materialTypes.cyan),
    outerInactiveMaterial: getMaterial(materialTypes.transparent),
    innerSize: 0.20,
    outerSize: 0.20,
  }

}